import React, { useEffect, useState } from 'react';
import { analyticsEvents } from '../utils/analytics';

interface MobileResultViewProps {
  frequency: number;
  onContinueToTherapy: () => void;
  onRestart?: () => void;
}

export const MobileResultView: React.FC<MobileResultViewProps> = ({
  frequency,
  onContinueToTherapy,
  onRestart,
}) => {
  const [showActions, setShowActions] = useState(false);

  useEffect(() => {
    // Track celebration view
    analyticsEvents.trackFeatureInteraction('mobile_result', 'celebration_shown', frequency);
    
    // Show actions after celebration period
    const timer = setTimeout(() => {
      setShowActions(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [frequency]);

  const handleContinueToTherapy = () => {
    analyticsEvents.trackFeatureInteraction('mobile_result', 'continue_to_therapy', frequency);
    onContinueToTherapy();
  };

  const handleRestart = () => {
    if (onRestart) {
      analyticsEvents.trackFeatureInteraction('mobile_result', 'restart_selected', frequency);
      onRestart();
    }
  };

  return (
    <div className="fixed inset-0 bg-white flex flex-col md:hidden z-50">
      {/* Stage 1: Celebration */}
      <div className="flex-1 flex flex-col justify-center items-center px-6">
        <div className="text-center">
          <div className="text-6xl mb-4 animate-bounce">🎉</div>
          <h1 className="text-2xl font-bold text-purple-700 mb-2">Found It!</h1>
          <div className="text-4xl font-bold text-purple-800 mb-8">{frequency} Hz</div>
        </div>

        {/* Stage 2: Actions (appear after celebration) */}
        <div className={`w-full max-w-sm transition-all duration-700 ${
          showActions ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}>
          <button
            onClick={handleContinueToTherapy}
            className="w-full py-4 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-bold rounded-xl text-lg transition-all duration-200 shadow-lg active:scale-95"
          >
            Try Your Sound Therapy →
          </button>
          
          {/* Optional restart - minimal and unobtrusive */}
          {onRestart && (
            <div className="text-center mt-6">
              <button
                onClick={handleRestart}
                className="text-gray-500 text-sm underline hover:text-gray-700 transition-colors"
              >
                Test again?
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Safe area padding for modern phones */}
      <div className="h-safe-area-inset-bottom" />
    </div>
  );
};